import { DateTime } from "luxon";
export function getSeriesDate(firstDate, lastDate) {
    let first = DateTime.fromISO(firstDate)
        .setLocale("en-US")

    let last = DateTime.fromISO(lastDate)
        .setLocale("en-US")
    // .toFormat("MMMM yyyy");
    let yearsDiffer = first.year == last.year ? false : true
    let monthsDiffer = first.month == last.month ? false : true

    let returnString
    if (yearsDiffer) {
        returnString = first.toFormat('MMMM yyyy') + ' - ' + last.toFormat('MMMM yyyy')
    } else if (monthsDiffer) {
        returnString = first.toFormat('MMMM') + ' - ' + last.toFormat('MMMM yyyy')
    } else {
        returnString = last.toFormat('MMMM yyyy')
    }

    return returnString
}
